export const module = {
  info: {
    name: 'voip-destination-side-menu',
    caption: 'voip destination side menu',
    viewGroup: 'general-modules'
  },
  vuexModules: [],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'Destinations',
    icon: 'el-icon-top-right',
    routeName: 'module->voip-destination->list->page',
    routeParams: { listPage: 1}
    /*children: [
      {
        caption: 'Create Entity',
        icon: 'el-icon-plus',
        routeName: 'module->voip-destination-side-menu->create'
      },
      {
        caption: 'List Entities',
        icon: 'el-icon-more-outline',
        routeName: 'module->voip-destination-side-menu->list->page',
        routeParams: { listPage: 1}
      }
    ]*/
  }
}

export default module
